import { TooltipDirective } from '@accesso/adk-portal-shared';
import { AfterViewInit, Component, ElementRef, Input, ViewChild } from '@angular/core';
import { ComponentContent } from '../../shared/models/product.model';

@Component({
  selector: 'card',
  standalone: true,
  imports: [TooltipDirective],
  templateUrl: './card.component.html',
  styleUrl: './card.component.scss',
})
export class CardComponent implements AfterViewInit {
  @Input() item?: ComponentContent | undefined;
  @Input() isOsCard = false;
  @Input() isFullCard = false;
  headerTooltipEnabled = false;
  subHeaderTooltipEnabled = false;

  @ViewChild('header', { static: false }) headerRef!: ElementRef;
  @ViewChild('subHeader', { static: false }) subHeaderRef!: ElementRef;

  ngAfterViewInit(): void {
    setTimeout(() => {
      if (this.headerRef && this.headerRef.nativeElement.scrollWidth > this.headerRef.nativeElement.clientWidth) {
        this.headerTooltipEnabled = true;
      }
      if (this.subHeaderRef && this.subHeaderRef.nativeElement.scrollWidth > this.subHeaderRef.nativeElement.clientWidth) {
        this.subHeaderTooltipEnabled = true;
      }
    });
  }
}
